"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var deviceCategories = exports.deviceCategories = {
    DESKTOP: [1000, Infinity],
    TABLET: [768, 999],
    MOBILE: [0, 767]
};

/**
 * check the window size to ascertain what category of device is currently in use
 */
var getDeviceCategory = exports.getDeviceCategory = function getDeviceCategory() {
    var deviceCategory = null;

    Object.keys(deviceCategories).forEach(function (dc) {
        if (window.innerWidth >= deviceCategories[dc][0] && window.innerWidth <= deviceCategories[dc][1]) {
            deviceCategory = dc;
            return dc;
        }

        return null;
    });

    return deviceCategory;
};


//////////////////
// WEBPACK FOOTER
// ./~/icarus-forms/module/js/lib/device.js
// module id = 197
// module chunks = 2 3